import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_ALLOW_EXTEND_AND_MODIFY_REQUEST: '',
  GET_ALLOW_EXTEND_AND_MODIFY_SUCCESS: '',
  GET_ALLOW_EXTEND_AND_MODIFY_FAILURE: '',

  POST_EXTEND_AUTH_REQUEST: '',
  POST_EXTEND_AUTH_SUCCESS: '',
  POST_EXTEND_AUTH_FAILURE: '',

  POST_MODIFY_AUTH_REQUEST: '',
  POST_MODIFY_AUTH_SUCCESS: '',
  POST_MODIFY_AUTH_FAILURE: '',

  POST_CANCEL_AUTH_REQUEST: '',
  POST_CANCEL_AUTH_SUCCESS: '',
  POST_CANCEL_AUTH_FAILURE: '',

  POST_EXPIRE_AUTH_REQUEST: '',
  POST_EXPIRE_AUTH_SUCCESS: '',
  POST_EXPIRE_AUTH_FAILURE: '',
};

types = setStoreTypeValues(types, 'authExtendAndModify');

export default types;
